import React, { useState } from "react";
import "../style/Login.css";
import { useMsal } from "@azure/msal-react";
import PuffLoader from "react-spinners/PuffLoader";
import { Container } from "reactstrap";
import logoImage from "../Content/images/Logo_600.jpg";
import { getUserFromUsername, setCookie, authenticateWithChief } from "../Services/ReportingService";
import { getEnvironment } from "../../src/Util/Utils";

const Login = (props) => {
  const [loading, setLoading] = useState(false);
  const { instance } = useMsal();

  const handleSubmit = async (event) => {
    event.preventDefault();

    let microsoftLoginUrl;

    if (getEnvironment() === "prod") {
      microsoftLoginUrl = "api://b4b48e64-6cdd-452a-ba2a-34bdeacfe294/access";
    } else {
      microsoftLoginUrl = "api://a77961a6-5a22-4701-87e8-31e03ad7ca56/access";
    }

    const loginResponse = await instance.loginPopup({
      scopes: [microsoftLoginUrl],
    });

    const accessToken = loginResponse.accessToken;
    setLoading(true);

    if (accessToken) {
      await setCookie({ name: "microsoft-token", value: accessToken, daysUntilExpire: 1 / 24 });
      await authenticateWithChief();

      sessionStorage.setItem("crmUser", JSON.stringify({}));
      sessionStorage.setItem("currentPage", JSON.stringify("UserSummary"));
      sessionStorage.setItem("username", loginResponse.account.username);

      const user = await getUserFromUsername(loginResponse.account.username);

      sessionStorage.setItem("userId", user.userGuid);
      sessionStorage.setItem("businessUnit", JSON.stringify(user.owningBusinessUnit));

      if (props.history) {
        props.history.push("/");
      }
    } else {
      setLoading(false);
      alert("Log In Failed");
    }
  };

  return (
    <Container>
      <form className="login-bg" onSubmit={handleSubmit}>
        <div style={{ display: "flex" }}>
          <div>
            <img
              alt="logo"
              style={{ width: "300px", height: "300px", borderRadius: "10px" }}
              id="citywide-img"
              src={logoImage}
            />
          </div>
          <div
            style={{
              flex: 1,
              display: "grid",
              gridTemplateRows: "1fr 1fr 1fr 1fr 1fr",
              justifyItems: "center",
            }}
          >
            <strong className="login-header" style={{ gridRow: 2 }}>
              CWFS Core
            </strong>
            <div style={{ gridRow: 4 }}>
              <button type="submit" data-testid="submit" className="btn btn-secondary btn-lg login-button">
                {!loading ? (
                  "Login"
                ) : (
                  <div className={`d-flex justify-content-center ${loading ? "" : "d-none"}`}>
                    <PuffLoader size={30} color={"#FFFFFF"} loading={loading} />
                  </div>
                )}
              </button>
            </div>
          </div>
        </div>
      </form>
    </Container>
  );
};

export default Login;
